 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TITLE_PAGE from '@/components/title_page'
 import LOVE_1 from '@/components/love_1'
 import CHAP240817 from '@/components/chap240817'
 import CHAP282256 from '@/components/chap282256'
 import CHAP240839 from '@/components/chap240839'
 import CHAP240840 from '@/components/chap240840'
 import CHAP240842 from '@/components/chap240842'
 import CHAP240834 from '@/components/chap240834'
 import CHAP240797 from '@/components/chap240797'
 import CHAP240835 from '@/components/chap240835'
 import CHAP240843 from '@/components/chap240843'
 import CHAP240820 from '@/components/chap240820'
 import CHAP240832 from '@/components/chap240832'
 import CHAP240816 from '@/components/chap240816'
 import CHAP240800 from '@/components/chap240800'
 import CHAP240798 from '@/components/chap240798'
 import CHAP240836 from '@/components/chap240836'
 import CHAP240802 from '@/components/chap240802'
 import CHAP240826 from '@/components/chap240826'
 import CHAP240827 from '@/components/chap240827'
 import CHAP240844 from '@/components/chap240844'
 import CHAP240824 from '@/components/chap240824'
 import CHAP240829 from '@/components/chap240829'
 import CHAP240805 from '@/components/chap240805'
 import CHAP240831 from '@/components/chap240831'
 import CHAP240812 from '@/components/chap240812'
 import CHAP240841 from '@/components/chap240841'
 import CHAP240825 from '@/components/chap240825'
 import CHAP240822 from '@/components/chap240822'
 import CHAP240814 from '@/components/chap240814'
 import CHAP240809 from '@/components/chap240809'
 import CHAP240838 from '@/components/chap240838'
 import CHAP240821 from '@/components/chap240821'
 import CHAP240801 from '@/components/chap240801'
 import CHAP240793 from '@/components/chap240793'
 import CHAP240799 from '@/components/chap240799'
 import CHAP240804 from '@/components/chap240804'
 import CHAP240794 from '@/components/chap240794'
 import CHAP240813 from '@/components/chap240813'
 import CHAP240803 from '@/components/chap240803'
 import CHAP240808 from '@/components/chap240808'
 import CHAP240796 from '@/components/chap240796'
 import CHAP240792 from '@/components/chap240792'
 import CHAP240830 from '@/components/chap240830'
 import CHAP240823 from '@/components/chap240823'
 import CHAP240806 from '@/components/chap240806'
 import CHAP240795 from '@/components/chap240795'
 import CHAP240807 from '@/components/chap240807'
 import CHAP240828 from '@/components/chap240828'
 import CHAP240833 from '@/components/chap240833'
 import LOVE_2 from '@/components/love_2'
 import CHAP240815 from '@/components/chap240815'
 import CHAP240845 from '@/components/chap240845'
 import CREDITS from '@/components/credits'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/chap240817",
 			"name" : "chap240817",
 			"component" : CHAP240817
 		},
 		{
 			"path" : "/chap282256",
 			"name" : "chap282256",
 			"component" : CHAP282256
 		},
 		{
 			"path" : "/chap240839",
 			"name" : "chap240839",
 			"component" : CHAP240839
 		},
 		{
 			"path" : "/chap240840",
 			"name" : "chap240840",
 			"component" : CHAP240840
 		},
 		{
 			"path" : "/chap240842",
 			"name" : "chap240842",
 			"component" : CHAP240842
 		},
 		{
 			"path" : "/chap240834",
 			"name" : "chap240834",
 			"component" : CHAP240834
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js